import * as T from "three/webgpu";
import Experience from "./Experience";
import { Inspector } from "three/addons/inspector/Inspector";
import PostProcess from "./Utils/PostProcess";

export default class Renderer {
  constructor() {
    this.experience = new Experience();

    this.canvas = this.experience.canvas;
    this.scene = this.experience.scene;
    this.camera = this.experience.camera;
    this.sizes = this.experience.sizes;
    this.debug = this.experience.debug;

    this.setInstance();
  }

  setInstance() {
    this.instance = new T.WebGPURenderer({
      canvas: this.canvas,
      antialias: true,
      alpha: true,
      // forceWebGL: true
    });
    if (this.debug && this.debug.active) {
      this.instance.inspector = new Inspector();
    }

    this.instance.init().then(() => {
      this.instance.toneMapping = T.CineonToneMapping;
      this.instance.toneMappingExposure = 1.75;
      this.instance.shadowMap.enabled = true;
      this.instance.shadowMap.type = T.PCFSoftShadowMap;
      // this.scene.background = new T.Color("#211d20");
      this.instance.setClearColor("#211d20");
      this.instance.setSize(this.sizes.width, this.sizes.height);
      this.instance.setPixelRatio(this.sizes.pixelRatio);
      this.instance.setAnimationLoop((elapsedTime) => {
        this.experience.time.tick(elapsedTime);
      });
      this.postProcess = new PostProcess(this.instance, this.scene, this.camera.instance);
      this.ready = true;
    });
  }

  resize() {
    this.instance.setSize(this.sizes.width, this.sizes.height);
    this.instance.setPixelRatio(this.sizes.pixelRatio);
  }

  update() {
    if (!this.ready) return;
    this.postProcess.render();
  }
}
